import ApiService from "../api";

export default class FilialService extends ApiService {

    constructor() {
        super('/api/filiais')
    }

    listar(data) {
        var params = "?"
        if (data?.tipoDistribuidor) {
            params += `tipoDistribuidor=${data.tipoDistribuidor} `
        }
        return this.get(`${params}`);
    }

    listarComComissao(ano, mes) {
        return this.get(`/com-comissao?ano=${ano}&mes=${mes}`);
    }

    listarAtivas() {
        return this.get(`/ativas`);
    }

    listarLogisticos(distribuidor) {
        return this.get(`/por-tipo?tipoDistribuidor=${distribuidor}`);
    }

    buscarPorCodigo(codigo) {
        return this.get(`/${codigo}`);
    }

    salvar(dto) {
        return this.post("", dto);
    }

    atualizar(codigo, dto) {
        return this.put(`/${codigo}`, dto);
    }

    excluir(codigo) {
        return this.delete(`/${codigo}`);
    }
}